export default function getCurrentUser() {
  try {
    const user = JSON.parse(localStorage.getItem("currentUser"));
    return user && typeof user === "object" && !Array.isArray(user) ? user : null;
  } catch {
    return null;
  }
}
